import { render, staticRenderFns } from "./detailsList.vue?vue&type=template&id=d34fc70c&scoped=true&"
import script from "./detailsList.vue?vue&type=script&lang=js&"
export * from "./detailsList.vue?vue&type=script&lang=js&"
import style0 from "./detailsList.vue?vue&type=style&index=0&id=d34fc70c&scoped=true&lang=less&"
import style1 from "./detailsList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34fc70c",
  null
  
)

export default component.exports